export const CountiesPopulation = `
Bedfordshire,706k,706
Berkshire,951k,951
Bristol,471k,471
Buckinghamshire,843k,843
Cambridgeshire,897k,897
Cheshire,1.098m,1098
City of London,8.6k,8.6
Cornwall,574k,574
Cumbria,501k,501
Derbyshire,1.058m,1058
Devon,1.219m,1219
Dorset,781k,781
Durham,862k,862
East Riding of Yorkshire,610k,610
East Sussex,823k,823
Essex,1.863m,1.863
Gloucestershire,937k,937
Greater London,8.788m,8788
Greater Manchester,2.868m,2868
Hampshire,1.860m,1860
Herefordshire,188k,188
Hertfordshire,1.201m,1201
Isle of Wight,141k,141
Kent,1.858m,1858
Lancashire,1.532m,1532
Leicestershire,1.079m,1079
Lincolnshire,1.097m,1097
Merseyside,1.423m,1423
Norfolk,918k,918
North Yorkshire,1.158m,1158
Northamptonshire,787k,787
Northumberland,322k,322
Nottinghamshire,1.146m,1146
Oxfordshire,727k,727
Rutland,41k,41
Shropshire,511k,511
Somerset,983k,983
South Yorkshire,1.374m,1374
Staffordshire,1.136m,1136
Suffolk,763k,763
Surrey,1.206m,1206
Tyne & Wear,1.126m,1126
Warwickshire,599k,599
West Midlands,2.916,2916
West Sussex,885k,885
West Yorkshire,2.350m,2350
Wiltshire,747k,747
Worcestershire,605k,605
    `;